<template>
  <v-container fluid>
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-account-check-outline
      </v-icon> Check-In
    </h2>
    <br>
    <v-card color="#CFD8DC">
      <div class="steps-style">
        <p><span :style="step1Success">Location Verification</span> -> <span :style="step2Success">Job Details</span> -> <br><span :style="step3Success">Q & A</span> -> Review Details</p>
      </div>
      <hr>
      <v-stepper
        v-model="userCheckIn"
        light
        class="my-stepper-style"
      >
        <v-stepper-header>
          <v-stepper-step
            :complete="userCheckIn > 1"
            step="1"
            color="#FF3700"
          />

          <v-divider />

          <v-stepper-step
            :complete="userCheckIn > 2"
            step="2"
            color="#FF3700"
          />

          <v-divider />

          <v-stepper-step
            :complete="userCheckIn > 3"
            color="#FF3700"
            step="3"
          />

          <v-divider />

          <v-stepper-step
            color="#FF3700"
            step="4"
          />
        </v-stepper-header>
      </v-stepper>
      <div>
        <location-verification
          v-if="showLocationVerificationPage"
          @verification-completed="toSecondStep"
        />
        <gather-job-details
          v-if="showJobDetailsPage"
          @job-details-stored="toThirdStep"
        />
        <questions-and-answers
          v-if="showQuestionsPage"
          @questions-answered="toFourthStep"
        />
        <review-job-details
          v-if="showReviewJobPage"
          @checkin-completed="checkInCompleted"
        />
      </div>
    </v-card>
  </v-container>
</template>
<script>
import LocationVerification from './LocationVerification.vue';
import GatherJobDetails from './GatherJobDetails.vue';
import QuestionsAndAnswers from './QuestionsAndAnswers.vue';
import ReviewJobDetails from './ReviewJobDetails.vue';

export default {
  name: 'CheckInLandingPage',
  components: {
    'location-verification': LocationVerification,
    'gather-job-details': GatherJobDetails,
    'questions-and-answers': QuestionsAndAnswers,
    'review-job-details': ReviewJobDetails,
  },
  data () {
    return {
      userCheckIn: 1,
      showLocationVerificationPage: true,
      step1SuccessColor: '',
      showJobDetailsPage: false,
      step2SuccessColor: '',
      showQuestionsPage: false,
      step3SuccessColor: '',
      showReviewJobPage: false,
    };
  },
  computed: {
    step1Success () {
      return `color:${this.step1SuccessColor}`;
    },
    step2Success () {
      return `color:${this.step2SuccessColor}`;
    },
    step3Success () {
      return `color:${this.step3SuccessColor}`;
    },
  },
  methods: {
    toSecondStep () {
      this.step1SuccessColor = '#00796B';
      this.userCheckIn = 2;
      this.showLocationVerificationPage = false;
      this.showQuestionsPage = false;
      this.showReviewJobPage = false;
      this.showJobDetailsPage = true;
    },
    toThirdStep () {
      this.step2SuccessColor = '#00796B';
      this.userCheckIn = 3;
      this.showLocationVerificationPage = false;
      this.showReviewJobPage = false;
      this.showJobDetailsPage = false;
      this.showQuestionsPage = true;
    },
    toFourthStep () {
      this.step3SuccessColor = '#00796B';
      this.userCheckIn = 4;
      this.showLocationVerificationPage = false;
      this.showReviewJobPage = false;
      this.showJobDetailsPage = false;
      this.showQuestionsPage = false;
      this.showReviewJobPage = true;
    },
    checkInCompleted () {
      this.$router.push({ name: 'Checkin Success' });
    },
  },
};
</script>
<style scoped>
.my-stepper-style {
  background-color: #CFD8DC;
}
.title-style {
  color: #37474F;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.steps-style {
  text-align: center;
  padding-top: 25px;
  color: #37474F;
  font-family:'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-weight: 500;
  font-size: 14px;
}
</style>
